







import { DomainRegistry } from "@/domain";
import { FolderHistory } from "@/domain/history";
import { Component, Mixins } from "vue-property-decorator";
import FolderHistoryTableView from "./FolderHistoryTableView.vue";

@Component({
  components: {
    FolderHistoryTableView,
  }
})
export default class FolderHistoryView extends Mixins() {
  data(): any {
    return {
      isLoading: false,
      histories: [] as FolderHistory[],
    };
  }
  isLoading: boolean;
  histories: FolderHistory[];

  created(): void {
    this.getFolderHistories().then(h => this.histories = h);
  }

  // TODO 余裕があるときにフィルタを追加

  async getFolderHistories(): Promise<FolderHistory[]> {
    try {
      this.isLoading = true;
      const repository = DomainRegistry.history.getHistoryRepository();
      return await repository.getFolderHistories();
    } catch (e) {
      this.$error("フォルダ一覧取得エラー", "フォルダ一覧の取得中にエラーが発生しました。", e);
    } finally {
      this.isLoading = false;
    }
  }
}
